export const MONITOR_ATTR = {
    // User
    USERID: 'userId',
    ROLE: 'userRole',
    PLATFORM: 'userPlatform',
    USER_IS_SUBSCRIBED: 'userIsSubscribed',
    USER_IS_SYNCED_IN_GRAPH_DB: 'userIsSyncedInGraphDb',

    // Errors
    ERROR_REASON: 'errorReason',

    // Search
    INCREMENTAL_SEARCH_INDEX_COUNT: 'indexCount',
    INCREMENTAL_SEARCH_INDEX_REINDEX_QUEUE_COUNT: 'reIndexCount',
    INCREMENTAL_SEARCH_INDEX_ITERATIONS: 'iterations',
    INCREMENTAL_SEARCH_INDEX_QUEUE_REMAINING: 'queueRemaining',

    // Export
    EXPORT_QUALITY: 'quality',

    // Reminders
    REMINDERS_COUNT: 'remindersCount',
    NOTIFICATIONS_COUNT: 'notificationsCount',

    // Notifications
    BOARD_EVENTS_COUNT: 'boardEventsCount',
    PENDING_UPDATE_NOTIFICATIONS_COUNT: 'pendingUpdateNotificationCount',
    PENDING_VIEW_NOTIFICATIONS_COUNT: 'pendingViewNotificationCount',

    // Expired notifications
    NOTIFICATIONS_TO_EXPIRE_COUNT: 'notificationsToExpireCount',
    NOTIFICATIONS_EXPIRED_COUNT: 'notificationsExpiredCount',

    // Activity digest
    EMAILS_SENT_COUNT: 'emailsSentCount',
    EMAILS_FAILED_COUNT: 'emailsFailedCount',
    DIGEST_USERS_COUNT: 'digestUsersCount',
    TIMEZONE_USERS_COUNT: 'timezoneUsersCount',

    USERS_COUNT: 'usersCount',
    ELEMENTS_COUNT: 'elementsCount',
    NAVIGATIONS_COUNT: 'navigationsCount',
    // Currently the elements count is being used in app-init to represent the work
    //  being done by the servers based on the number of elements retrieved.
    // This represents the number of elements found from traversals (without using the cache)
    FRESH_ELEMENTS_COUNT: 'freshElementsCount',
    ELEMENTS_ERROR_COUNT: 'elementsErrorCount',
    COMMENTS_COUNT: 'commentsCount',
    ERRORS_COUNT: 'errorsCount',

    // The total number of images inside all boards requested
    IMAGES_COUNT: 'imagesCount',

    // The max number of images out of the boards requested,
    // will be same number as IMAGES_COUNT if only 1 board is requested
    IMAGE_PER_BOARD_MAX: 'imagesPerBoardMax',

    // Delete removed users
    USERS_DELETED_COUNT: 'usersDeletedCount',

    USERS_TEAM_SIZE: 'usersTeamSize',

    // Delete old trashed elements
    // Delete empty trashed elements
    ELEMENTS_MARKED_AS_DELETED_COUNT: 'elementsMarkedAsDeletedCount',
    ELEMENTS_DELETED_COUNT: 'elementsDeletedCount',
    ELEMENTS_FAILED_DELETION_COUNT: 'elementsFailedDeletionCount',

    // Domain subscription expiry
    USERS_SUBSCRIPTIONS_RENEWAL_COUNT: 'usersSubscriptionsRenewalCount',
    USERS_SUBSCRIPTIONS_RENEWAL_FAILED_COUNT: 'usersSubscriptionsRenewalFailedCount',
    USERS_SUBSCRIPTIONS_REMOVED_COUNT: 'usersSubscriptionsRemovedCount',
    USERS_SUBSCRIPTIONS_REMOVE_FAILED_COUNT: 'usersSubscriptionsRemoveFailedCount',

    // Phishing analysis
    BOARD_COUNT: 'boardCount',
    PUBLISHED_BOARD_COUNT: 'publishedBoardCount',
    SUSPICIOUS_BOARD_COUNT: 'suspiciousBoardCount',
    FAILED_BOARD_COUNT: 'failedBoardCount',

    // Action attributes
    OPERATION: 'operation',
    REQUEST_MODE: 'requestMode',

    // Image search rate limits
    IMAGE_SEARCH_PROVIDER_RATE_LIMIT: 'imageSearchProviderRateLimit',

    // Update conflict
    ELEMENT_ID: 'elementId',
    UPDATE_CONFLICT_STATUS: 'updateConflictStatus',

    // Element restoration
    ELEMENT_RESTORATION_TYPE: 'elementRestorationType',

    // Search
    SEARCH_ENRICHED_BREADCRUMBS_LENGTH: 'enrichedBreadcrumbsLength',

    // Sync Graph DB metrics
    ELEMENTS_CREATED: 'elementsCreated',
    CREATOR_RELATIONSHIPS_CREATED: 'creatorRelationshipsCreated',
    CHILD_OF_RELATIONSHIPS_CREATED: 'childOfRelationshipsCreated',
    TRASH_OF_RELATIONSHIPS_CREATED: 'trashOfRelationshipsCreated',
    DELETED_FROM_RELATIONSHIPS_CREATED: 'deletedFromRelationshipsCreated',
    PARENT_CHILD_RELATIONSHIPS_DELETED: 'parentChildRelationshipsDeleted',
    LINKED_FROM_RELATIONSHIPS_CREATED: 'linkedFromRelationshipsCreated',
    ALIAS_USES_RELATIONSHIPS_CREATED: 'aliasUsesRelationshipsCreated',
    USER_ACCESS_RELATIONSHIPS_CREATED: 'userAccessRelationshipsCreated',
    USER_ACCESS_RELATIONSHIPS_DELETED: 'userAccessRelationshipsDeleted',
    USER_USES_RELATIONSHIPS_CREATED: 'userUsesRelationshipsCreated',
    PERMISSIONS_CREATED: 'permissionsCreated',
    PERMISSION_ACCESS_RELATIONSHIPS_CREATED: 'permissionAccessRelationshipsCreated',

    QUEUE_SIZE: 'queueSize',
};

export const MONITOR_TRANSACTION = {
    WEBSOCKET: 'WS',
    ACTION: 'action',
    BROADCAST_ACTION: 'broadcast',
    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
};

export const MONITOR_ATTR_USER_TEAM_SIZE = {
    ONE: '1',
    UPTO_SEVEN: '<= 7',
    UPTO_TWENTY: '<= 20',
    UPTO_FIFTY: '<= 50',
    MORE_THAN_FIFTY: '> 50',
};

// This action should be used if logging specific events for New Relic
export const LOGGING_ACTION_TYPE = 'LOG';
